import { useLayoutEffect } from 'react';
import * as React from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { TransitionProps } from '@mui/material/transitions';
import BounakirMessage from '../../pages/DoubleMatch/BounakirMessage';
import { useHistory, useLocation } from 'react-router-dom';
import BreakTheIceQuestion from '../../pages/BreakTheIce/BreakTheIceQuestion';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});



const BreakTheIceModal = NiceModal.create(({ handleNext, messageId, questionTitle, questionId }: any) => {
    const modal = useModal();
    const location = useLocation();
    const history = useHistory();
    const openModalHashStateId = `${location.pathname}${location.search}&popup=breakTheIce`;


    useLayoutEffect(() => {
        const listen = history.listen(historyBack);
        if (modal.visible) {
            window.history.pushState({ openModalHashStateId }, `${openModalHashStateId}`, `${openModalHashStateId}`)
        }
        return () => listen();
    }, [modal.visible])

    const historyBack = () => {

        modal.hide();
    }

    const handleModalToggle = () => {
        history.goBack();
        modal.hide();
    };



    return (
        <>
            <div>
                <Dialog

                    fullScreen
                    TransitionComponent={Transition}
                    open={modal.visible}
                    onClose={handleModalToggle}
                >
                    <div className='breakTheIce-container' style={{ overflowY: "auto" }}>
                        <BreakTheIceQuestion
                            questionId={questionId}
                            questionTitle={questionTitle}
                            messageId={messageId}
                            handleNext={handleNext} />
                    </div>

                </Dialog>
            </div>
        </>


    )
})


export default BreakTheIceModal;